import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { postFormDataSetupProfileApiCaller } from "../../../Libs/apiCaller";
import { toast } from "react-toastify";
import { useCookies } from "react-cookie";

export default function AboutUserProfile({ ProfileImage }) {
  const [isLoading, setIsLoading] = useState(false);
  const [, , removeCookie] = useCookies(["token"]);
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      visibility: "Everyone",
    },
    validationSchema: Yup.object({
      visibility: Yup.string().required("visibility is required"),
    }),
    onSubmit: async (values) => {
      setIsLoading(true);
      const formData = new FormData();
      formData.append("privacy", values.visibility);
      if (typeof ProfileImage === "string") {
        formData.append("avtarId", ProfileImage);
      } else {
        formData.append("UserMedia", ProfileImage);
      }
      const endPoint = "users/update_user";
      const response = await postFormDataSetupProfileApiCaller(
        endPoint,
        formData
      );
      if (response?.status === 200) {
        removeCookie("token", {
          path: "/",
          secure: true,
          httpOnly: false,
          sameSite: "Strict",
        }); // Remove authentication token
        navigate(`/success-profile`, { state: response.data });
        formik.resetForm();
      } else {
        toast.error(response?.response?.data?.message || response?.message);
      }
      setIsLoading(false);
    },
  });

  return (
    <section className="bg-login p-6 md:p-4 pb-16 sm:pb-0 min-h-screen flex items-center justify-center overflow-x-hidden">
      <form
        onSubmit={formik.handleSubmit}
        className="w-full max-w-lg p-8 text-center"
      >
        <h2 className="text-2xl font-bold mb-10 capitalize">
          Let us know more about you.
        </h2>

        {/* Who can see your phone number dropdown */}
        <div className="mb-6 text-left">
          <label className="block mb-2 font-normal">
            Who can see your phone number
          </label>
          <select
            name="visibility"
            value={formik.values.visibility}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="select bg-white select-bordered rounded-lg h-12 w-full"
          >
            <option value="Everyone">Everyone</option>
            <option value="Friends">Friends</option>
            <option value="Nobody">Nobody</option>
          </select>
          {formik.touched.visibility && formik.errors.visibility && (
            <p className="text-red-500 text-sm mt-1 errorMsg">
              {formik.errors.visibility}
            </p>
          )}
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          className="w-full bg-[var(--primary-color)] text-white py-3 rounded-full text-lg font-medium hover:bg-purple-500 transition"
          disabled={isLoading}
        >
          {isLoading ? "Loading..." : "Done"}
        </button>
      </form>
    </section>
  );
}
